import React, { memo, useEffect, useState } from 'react';
import { Column, Grid, Link, Row } from '@carbon/react';

import { Page } from 'components/Page';
import {
  Panel,
  PanelHeader,
  PanelIcon,
  PanelLabel,
  PanelFooter,
  PanelLink,
  PanelStatistics,
} from 'components/Panel';
import Panels from 'components/Panels';

import { Email, Password, Home, DeliveryTruck, Add } from '@carbon/react/icons';
import '../_overrides.scss';
import useUser from '@/lib/hooks/useUser';
import { useGetUserQuery } from '@/redux/new_services/user';
import { useNavigate } from 'react-router-dom';


export const Overview = memo(({ handleNavChange }) => {

  const navigate = useNavigate();

  const { isAdmin, userID} = useUser();
  const {data: raw_user, isLoading} = useGetUserQuery("me");

  const [user, setUser] = useState({});
  const [organisation, setOrganisation] = useState({});

  useEffect(() => {
    if (raw_user && raw_user.user) {
      setUser(raw_user.user);
    }
    if (raw_user && raw_user.organisation) {
      setOrganisation(raw_user.organisation);
    }
  }, [raw_user])

  const handleEdit = () => {
  }

  return (
    <Page pageTitle="Konto Verwaltung" hasSideNav>

      <Grid fullWidth>
        <Column lg={8} md={8} sm={4}>
          {user && user.firstname && (
            <Panel doubleHeight>
              <PanelHeader header></PanelHeader>
              <PanelIcon showRed={isAdmin}>
                {user.firstname[0]}
                {user.lastname[0]}
              </PanelIcon>
              <PanelHeader centered withSubtitle>
                {user.firstname} {user.lastname}
              </PanelHeader>
              <PanelLabel centered>
                {organisation && organisation.name}
              </PanelLabel>
              <div className="profile_item">
                <div className="profile_icon">
                  <Email />
                </div>
                <div className="profile_text">{user.email}</div>
                <br />
                <div className="profile_icon_space"></div>
              </div>

              {organisation && organisation.billing_address && (
                <div className="profile_item">
                  <div className="profile_icon">
                    <Home />
                  </div>
                  <div className="profile_text profile_text-head">
                    {organisation.billing_address.name ||
                      organisation.name}
                  </div>
                  <br />
                  <div className="profile_icon_space"></div>
                  <div className="profile_text">
                    {organisation.billing_address.street}
                  </div>
                  <br />
                  <div className="profile_icon_space"></div>
                  <div className="profile_text">
                    {organisation.billing_address.postcode}
                  </div>
                  &nbsp;
                  <div className="profile_text">
                    {organisation.billing_address.city}
                  </div>
                  <br />
                  <div className="profile_icon_space"></div>
                </div>
              )}

              {organisation && organisation.delivery_address && (
                <div className="profile_item">
                  <div className="profile_icon">
                    <DeliveryTruck />
                  </div>
                  <div className="profile_text profile_text-head">
                    {organisation.delivery_address.name ||
                      organisation.name}
                  </div>
                  <br />
                  <div className="profile_icon_space"></div>
                  <div className="profile_text">
                    {organisation.delivery_address.street}
                  </div>
                  <br />
                  <div className="profile_icon_space"></div>
                  <div className="profile_text">
                    {organisation.delivery_address.postcode}
                  </div>
                  &nbsp;
                  <div className="profile_text">
                    {organisation.delivery_address.city}
                  </div>
                  <br />
                  <div className="profile_icon_space"></div>
                </div>
              )}

              <hr />
            </Panel>
          )}
        </Column>
        <Column lg={8} md={8} sm={4}>
          <Panel halfSize>
            <PanelHeader
              header
            >
              Kennwort
            </PanelHeader>

            <PanelStatistics>
              <Password size={32} width={64} height={64} />
            </PanelStatistics>
            <PanelLabel semi>
            Verstärke die Kennwortsicherheit, oder änder Dein Kennwort, wenn
                jemand anderes Kenntnis darüber hat.
            </PanelLabel>
            <PanelFooter>
              <PanelLink
                onClick={() => navigate('/me/change_password')}
                icon={<Add size={32} />}>
                KENNWORT ÄNDERN
              </PanelLink>
            </PanelFooter>
          </Panel>


          {!isAdmin && (
            <Panels.Licences
              small
              userID={userID}
            />
          )}
        </Column>
      </Grid>
    </Page>
  );
});

/**
 *
 * <Column md={4}>
              <Panel>
                <PanelHeader centered>
                  Benutzer
                  <br />
                  <UserMultiple32 width={64} height={64} />
                </PanelHeader>
                <PanelLabel centered>
                  Verwalten Sie zusätzliche Benutzer, die in für Sie Content
                  Verwalten.
                </PanelLabel>
                <PanelLink>BENUTZER VERWALTEN &gt;</PanelLink>
                <PanelFooter></PanelFooter>
              </Panel>
            </Column>

            {!isAdmin && (
              <Column md={4}>
                <Panel>
                  <PanelHeader centered>
                    Abonnements
                    <br />
                    <Purchase32 width={64} height={64} />
                  </PanelHeader>
                  <PanelLabel centered>Ihnen zugewiesene Lizenzen</PanelLabel>
                  <PanelLink>ANSICHT &gt;</PanelLink>
                  <PanelFooter></PanelFooter>
                </Panel>
              </Column>
            )}
 */
